require('zone.js/dist/zone.js');
require('zone.js/dist/long-stack-trace-zone');
//# sourceMappingURL=zone-browser.js.map


//////////////////
// WEBPACK FOOTER
// ./~/angular2-universal-polyfills/zone-browser.js
// module id = 547
// module chunks = 0